<template>
  <div
    class="h-full max-md:min-h-[60dvh] flex flex-col grow py-2 px-3 md:px-6 bg-secondary overflow-x-hidden overflow-y-auto scrollbar-quaternary"
  >
    <template v-if="tree.every((item) => isEmpty(item.children))">
      <div class="flex justify-center mt-8">
        <State
          :type="state.type"
          :title="state.title"
          :text="state.text"
          :button="state.button"
        />
      </div>
    </template>
    <template v-else>
      <TreeNode
        v-for="node in tree"
        :key="node.id"
        :type="type"
        :node="node"
        :level="1"
        :disabledItems="disabledItems"
        :breadcrumb="node.name"
        :searchTerm="searchTerm"
        :selectedNodeIds="selectedNodeIds"
        :shouldAutoOpen="!!buildingId"
        :multiple="multiple"
        :showBuildings="!!!buildingId"
        :buildingIsSelectable="buildingIsSelectable"
        @updateState="$emit('update:modelValue', $event)"
      />
    </template>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { isEmpty } from "lodash";
import { storeToRefs } from "pinia";
import { State, useState } from "@/SharedComponents/State";
import { TreeNode } from "@/SharedComponents/Tree";
import { useSpacesAndAssetsTree } from "@/Composables/useSpacesAndAssetsTree";

const emit = defineEmits([
  "update:modelValue",
  "update:assets",
  "update:includeAssets",
]);

const props = defineProps({
  type: { type: String, required: true },
  modelValue: { type: Object, default: () => ({}) },
  buildingId: { type: String, default: null },
  buildings: { type: Array, required: true },
  disabledItems: { type: Array, default: () => [] },
  searchTerm: { type: String, required: false },
  selectedNodeIds: { type: Object, required: true },
  multiple: { type: Boolean, default: true },
  buildingIsSelectable: { type: Boolean, default: true },
});

const _buildings = computed(() =>
  props.buildingId
    ? props.buildings.filter((building) => building.id === props.buildingId)
    : props.buildings
);

const { tree } = useSpacesAndAssetsTree(
  _buildings.value,
  props.type,
  props.modelValue,
  emit
);

const stateStore = useState(props.type);
const { state } = storeToRefs(stateStore);
</script>
